import type { ApiDriver } from '~/api/types';

export type DriversByClientState = Record<string, ApiDriver[]>;

export interface AddDriverByClientPayload {
    /**
     * The client ID to add the driver to
     */
    clientId: string;

    /**
     * The driver data to add
     */
    data: ApiDriver;
}

export interface UpdateDriversByClientPayload {
    /**
     * The client ID to update the driver in
     */
    clientId: string;

    /**
     * The driver ID to update
     */
    driverId: string;

    /**
     * The driver data to be updated to
     *
     * This data will replace the old `ApiDriver` value
     */
    data: ApiDriver;
}

export interface RemoveDriverByIdPayload {
    /**
     * The client ID to remove the driver in
     */
    clientId: string;

    /**
     * The driver ID to remove
     */
    id: string;
}

export const defaultDriversByClientState: DriversByClientState = {};
